import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModal } from 'shared/abstract/base-modal';
import { SafeHtmlPipe } from 'shared/pipes/safeHtml.pipe';

@Component({
    selector: 'app-delete-confirmation-modal',
    templateUrl: './delete-confirmation-modal.component.html',
    styleUrls: ['../modal.component.scss'],
    imports: [TranslateModule, NgClass, SafeHtmlPipe],
})
export class DeleteConfirmationModalComponent extends BaseModal implements OnInit {
    public data!: {
        title: string;
        body: string;
        deletedEntityCompanyName: string;
        deletedEntityName: string | string[];
        deletedEntityType: string;
        isWithCompanyConfirmation: boolean;
        confirmationInputPlaceholder: string;
        type: 'top' | 'side' | 'center';
        shouldNotTranslatePlaceholder: boolean;
        additionalWarningText: string;
        mainButtonTextOverwrite: string;
        usePrimaryButtonColor: boolean;
        useOrderedList: boolean;
    };

    isArrayOfEntities: boolean = false;

    public confirmationInput: string = '';

    constructor() {
        super();
    }

    public ngOnInit(): void {
        this.isArrayOfEntities = Array.isArray(this.data.deletedEntityName);
    }

    public close(result: boolean): void {
        this.closeModalInstance(result);
    }

    public confirmationInputOnInput($event: any) {
        this.confirmationInput = $event?.target.value;
    }

    public get isConfirmed(): boolean {
        const expected = this.data.deletedEntityName;

        return typeof expected === 'string' && this.normalizeText(this.confirmationInput) === this.normalizeText(expected);
    }

    // Consider special dashes and quotes e.g. — (special) vs. - (keyboard)
    private normalizeText(value: string): string {
        return value
            .normalize('NFC')
            .replace(/[\u2010-\u2015\u2212]/g, '-')
            .replace(/[\u2018\u2019\u02bc\u2032]/g, "'")
            .replace(/[\u201c\u201d\u2033]/g, '"')
            .replace(/\s+/g, ' ')
            .trim();
    }
}
